export default __webpack_public_path__ + "static/media/6.0016b9cc.svg";